<template>
  <div class="project-rank-list">
    <div class="title-bar">
      <a-row type="flex" justify="space-between">
        <a-col :span="2">
          <a-icon type="crown" theme="twoTone" />
          <h3 class="title">作品</h3>
        </a-col>
        <a-col :span="8">
          <a-row type="flex" justify="start">
            <a-col :span="3">
              <a-tag
                class="work-tags"
                :color="'' === workTag ? '#108ee9' : 'blue'"
                @click="clickWorkTag('')"
              >
                全部
              </a-tag>
            </a-col>
            <a-col :span="3" v-for="item in workTags" :key="item.value">
              <a-tag
                class="work-tags"
                :color="item.text === workTag ? '#108ee9' : 'blue'"
                @click="clickWorkTag(item.text)"
              >
                {{ item.text }}
              </a-tag>
            </a-col>
          </a-row>
        </a-col>
        <a-col :span="12">
          <a-select v-model="codeType" @change="getWorkRank()">
            <a-select-option key="all" value="">全部类型</a-select-option>
            <a-select-option
              v-for="item in codeTypes"
              :key="item.value"
              :value="item.value"
              >{{ item.text }}
            </a-select-option>
          </a-select>
          <a-divider type="vertical" />
          <a-select @change="getWorkRank()" v-model="workRankCycle">
            <a-select-option key="all" value="">全部时间</a-select-option>
            <a-select-option key="week" value="week">最近一天</a-select-option>
            <a-select-option key="week" value="week">最近一周</a-select-option>
            <a-select-option key="year" value="year">最近一年</a-select-option>
          </a-select>
          <a-divider type="vertical" />
          <a-select @change="getWorkRank()" v-model="workRankOrderBy">
            <a-select-option key="time" value="time">最新作品</a-select-option>
            <a-select-option key="star" value="star">点赞最高</a-select-option>
            <a-select-option key="view" value="view">点击最高</a-select-option>
          </a-select>
          <a-divider type="vertical" />
          <a-input-search
            v-model="workName"
            style="width: 200px"
            placeholder="搜索作品"
            enter-button
            @search="getWorkRank"
          />
        </a-col>
      </a-row>
      <a-divider />
    </div>
    <div class="project-list">
      <a-empty :description="'暂无数据'" v-if="!spinning && workRankResult.total == 0" />
      <a-spin :spinning="spinning" >
        <a-row v-if="workRankResult.total > 0">
          <a-col
            :span="6"
            v-for="(item, index) in workRankResult.records"
            :key="index"
          >
            <a-card hoverable style="width: 250px">
              <div slot="cover" @click="$toProjectDetail(item.id)">
                <a-tag class="work-type" color="blue">{{
                  item.codeType_dictText
                }}</a-tag>
                <img :src="item.workCover_url" />
              </div>
              <div class="work-count">
                <a-icon type="eye" /> {{ item.viewNum }}
                <a-divider type="vertical" />
                <a-icon type="like" /> {{ item.starNum }}
                <a-divider type="vertical" />
                <a-icon type="heart" /> {{ item.collectNum }}
                <a-divider type="vertical" />
                <a-icon type="message" /> {{ item.commentNum }}
              </div>
              <template slot="actions" class="ant-card-actions">
                <div @click="$toUserDetail(item.userId)">
                  <a-avatar
                    slot="avatar"
                    icon="user"
                    :src="item.avatarUrl || '/img/avatar.png'"
                  />
                  {{ item.realname }}
                </div>
              </template>
              <a-card-meta :title="item.workName"> </a-card-meta>
            </a-card>
          </a-col>
        </a-row>
      </a-spin>
    </div>
    <div class="page">
      <a-pagination
        show-quick-jumper
        :default-current="workRankResult.current"
        :total="workRankResult.total"
        :defaultPageSize="greatWorkResult.size"
        @change="changePage"
      />
    </div>
  </div>
</template>

<script>
import { getWorkRank } from "@/api/community";
import { getDict } from "@/api/sys";
export default {
  name: "ProjectRankList",
  components: {},
  data() {
    return {
      workTags: [],
      codeTypes: [],
      workRankResult: {},
      greatWorkResult: {},

      workRankCycle: "year",
      workRankOrderBy: "star",
      workTag: "",
      codeType: "",
      workName: "",

      currentPage: 1,
      page: 1,
      spinning: true,
    };
  },
  created() {
    this.getWorkRank();
    this.getWorkTags();
    this.getCodeTypes();
  },
  methods: {
    getWorkTags() {
      getDict("work_tag").then((res) => {
        if (res.success) {
          this.workTags = res.result;
        }
      });
    },
    getCodeTypes() {
      getDict("code_type").then((res) => {
        if (res.success) {
          this.codeTypes = res.result;
        }
      });
    },
    changePage(page) {
      this.getWorkRank(page);
    },
    clickWorkTag(tag) {
      this.workTag = tag;
      this.getWorkRank();
    },
    getWorkRank(page) {
      if (!page) {
        this.currentPage = 1;
      }
      this.spinning = true;
      getWorkRank(
        this.workRankCycle,
        this.workRankOrderBy,
        this.workName,
        this.codeType,
        this.workTag,
        page || 1,
        8
      ).then((res) => {
        this.spinning = false;
        if (res.success) {
          this.workRankResult = res.result;
        } else {
          that.$message.error({
            title: "错误",
            description: res.message,
          });
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.project-rank-list {
  min-height: 500px;
  .title-bar {
    text-align: left;
    margin: 50px 10px;
    i {
      font-size: 25px;
    }
    .title {
      font-size: 20px;
      font-weight: 700;
      color: white;
      margin-left: 10px;
      display: inline;
      text-shadow: 0px 0px 2px black;
    }
  }

  .project-list {
    .ant-card {
      box-shadow: 1px 2px 6px 0px #b6b6b6;
      margin-bottom: 30px;
    }
    .ant-card-cover {
      img {
        width: 100%;
        min-height: 190px;
      }
    }
    .work-count {
      text-align: left;
      color: #9e9e9e;
      margin-bottom: 5px;
    }
    .work-type {
      position: absolute;
      background: #e6f7ff80;
      border-color: #91d5ff85;
      top: 2px;
      left: 2px;
    }
  }

  .page {
    margin: 50px 10px;
  }
}
</style>